
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Chinese from "./language/Chinese.js"//简体中文
import English from "./language/English.js"//英文
import Traditional from "./language/Traditional.js"//繁体中文
import Japanese from "./language/Japanese.js"//日语
import Vietnamese from "./language/Vietnamese.js"//越南语
import Malay from "./language/Malay.js"//马来语
import Hindi from "./language/Hindi.js"//印度语
import Thai from "./language/Thai.js"//泰语
import Russian from "./language/Russian.js"//俄语
import Indonesian from "./language/Indonesian.js"//印尼语
Vue.use(VueI18n)

export const i18n = new VueI18n({
	locale: localStorage.getItem('language') || 'Chinese',
	messages: {
		'Chinese': Chinese,//简体中文
		'English': English,//英文
		'Traditional': Traditional,//繁体中文
		'Japanese': Japanese,//日语
		'Vietnamese': Vietnamese,//越南语
		'Malay': Malay,//马来语
		'Hindi': Hindi,//印度语
		'Thai': Thai,//泰语
		'Russian': Russian,//俄语
		'Indonesian': Indonesian,//印尼语
	},
	silentTranslationWarn: process.NODE_ENV === 'production' // true 去除console中黄色报错
})

Vue.use({
	i18n: (key, value) => i18n.t(key, value)
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js